import React, { Component } from 'react';
import UserInfo from 'components/base/secure/header/user-info';
import logo from 'assets/img/budgetti_logo.svg';
import PageTitle from 'components/base/secure/header/page-title';
import Navbar from 'components/base/secure/header/navbar';

/*  eslint-disable jsx-a11y/href-no-hash */
/*  eslint-disable jsx-a11y/anchor-has-content */
class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };

        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(state => ({
            open: !state.open,
        }));
    }

    render() {
        const { open } = this.state;

        return (
            <div className="header" ref={this.props.innerRef}>
                <div className="container">
                    { /* Top with user info and sidebar toggle */ }
                    <div className="header-inner header-md-height">
                        <a href="#"
                           className="btn-link toggle-sidebar d-lg-none pg pg-menu"
                           onClick={this.toggle}
                        />
                        <ul className="d-lg-inline-block d-none notification-list no-margin b-grey b-l b-r no-style p-l-0 p-r-20" />
                        {/*<Notifications />*/}

                        <div className="d-flex align-items-center">
                            { /* User info */ }
                            <UserInfo />
                            { /* Right sidebar toggle */ }
                            {/*<a href="#" className="header-icon pg pg-alt_menu btn-link m-l-10 sm-no-margin d-inline-block"
                               data-toggle="quickview" data-toggle-element="#quickview"
                            />*/}
                        </div>
                    </div>

                    { /* Logo and page title */ }
                    <div className="header-inner justify-content-start header-lg-height title-bar">
                        <div className="brand inline align-self-end" style={{marginBottom: -6}}>
                            <img src={logo} alt="logo" width="100" height="30"
                            />
                        </div>
                        <PageTitle />
                    </div>

                    { /* Menu */ }
                    <div className={`menu-bar header-sm-height ${open ? 'open' : null}`}>
                        <a href="#"
                           className="btn-link toggle-sidebar d-lg-none pg pg-close"
                           onClick={this.toggle}
                        />
                        <Navbar />
                        <a href="#" className="search-link d-flex justify-content-between align-items-center d-lg-none"
                           data-toggle="search"
                        >
                            Tap here to search
                            <i className="pg-search float-right" />
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default React.forwardRef((props, ref) => <Header {...props} innerRef={ref} />);


// WEBPACK FOOTER //
// ./src/components/base/secure/header/header.js